<div class="aip-spa-container" role="main">
  <app-mutual-fund-investing></app-mutual-fund-investing>
</div>
